import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-price-input',
    templateUrl: './price-input.component.html',
    styleUrls: ['./price-input.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class PriceInputComponent {

  @Input() form: UntypedFormGroup;

}
